import React from "react";
import styled from "styled-components";

export default styled.div`
    border: 1px solid #CECEDC;
    width: 100%;
    height: 48px;
    padding: 5px;
    padding-top: 14px;
    margin-bottom: 12px;
`;